import {Banner} from "../../domain/dtos/banner"

export class BannerMapper {
    static deserialize(param: any): Banner | null {
        // The API returns an array with a single element.
        const banner = param.results[0];
        if (banner == null) {
            return null;
        }
        return {
            description: banner?.description,
            image: banner?.image,
            link: banner?.link
        }
    }
}
